// extracted by mini-css-extract-plugin
export default {"StrollerDetailRating":"xm_a bhp_a bhp_x","StrollerDetailRating__muted":"xm_b bhp_fo"};